import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, QueryList, SimpleChanges, TemplateRef, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionType, ProductTagsService, ProductAttributesService, RolePermissionService, UtilitiesService } from 'lib-core-shared';
import { of, Subject } from 'rxjs';
import { TabItem } from './models/tab-item-model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-tabs',
  templateUrl: './lib-tabs.component.html',
  styleUrls: ['./lib-tabs.component.scss']
})
export class LibTabsComponent implements OnChanges, OnInit {
  public authenticatedTabList: TabItem[] = [];
  public authenticatedTabList$: any;
  @ViewChildren('tabTemplate') tabTemplates!: QueryList<TemplateRef<any>>
  @Input() tabList: TabItem[] = [];
  @Input() public tabSelected: number = 0;
  @Input() public allowPermission = true;
  @Input() isPIM?: boolean;
  @Input() tabBgColor: string = '#2c3e50'
  @Input() usedInTab?: boolean;
  @Input() initialisTab$ = new Subject<number>();

  unsavedChangesOnTagsSubscription: any;
  unsavedChangesOnTagsTab?: boolean;
  unsavedChangesOnAttributesSubscription: any;
  unsavedChangesOnAttributesTab?: boolean;

  constructor(private utilitiesService: UtilitiesService, 
              private ref: ChangeDetectorRef,
              private route:ActivatedRoute,
              private router:Router,
              private roleService: RolePermissionService,
              private productAttributesService: ProductAttributesService,
              private productTagsService: ProductTagsService
            ) { 
                this.initialisTab$.subscribe(index => {
                  if (this.tabTemplates.length) {
                    this.ref.markForCheck();
                  }
                });
              }

  ngOnInit(): void {
    this.unsavedChangesOnTagsSubscription = this.productTagsService.unsavedChangesOnTagsTabObs.subscribe(status => {
      this.unsavedChangesOnTagsTab = status;
    })
    this.unsavedChangesOnAttributesSubscription = this.productAttributesService.unsavedChangesOnAttributesTabObs.subscribe(status => {
      this.unsavedChangesOnAttributesTab = status;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    const latest = changes['tabList'];
    if (latest.currentValue?.length) {
      this.authenticatedTabList = [];
      this.tabList.forEach(tab => {
        if (tab.permission || !this.allowPermission) {
          const permissionOutcome = this.roleService.getPermission(tab.permission);
          if (permissionOutcome === PermissionType.read || !this.allowPermission || tab.permission == 'overRulePermission') {
            this.authenticatedTabList.push(tab);
          }
        }
      });
      this.authenticatedTabList$ = of(this.authenticatedTabList);
    }
  }

  public changeTab(selection: number) {
    const showModal = () => {
      this.utilitiesService.unSavedChangesConfirm = true;
      this.utilitiesService.unSavedChangeConfirmation(proceedSelection, 'You have unsaved changes. Do you want to leave this page and discard those changes?');
    }

    const proceedSelection = () => {
      this.utilitiesService.unSavedChangesConfirm = false;
      this.tabSelected = selection;
      if (this.authenticatedTabList[selection].groupSubject$) {
        this.router.navigate([`../${this.authenticatedTabList[selection].name}`], this.utilitiesService.buildNavExtras(this.route, null, true));
        this.ref.detectChanges(); //without this the page url changes but the view doesn't update
      }
    };

    if (this.authenticatedTabList[this.tabSelected]?.group?.dirty) {
      showModal();
    // attributes tab doesn't use a form so we cant detect unsaved changes by checking if its dirty... below we detect that a user is leaving the attributes tab, we then check for
    // unsaved changes by using a variable (unsavedChangesOnAttributesTab), which is populated and updated via an observable where the value is set and updated in the attributes tab
    } else if (this.authenticatedTabList[this.tabSelected].name === 'attributes') {
      if (this.unsavedChangesOnAttributesTab) {
        showModal();
      } else {
        proceedSelection();
      }
    // tags tab doesn't use a form so we cant detect unsaved changes by checking if its dirty... below we detect that a user is leaving the tags tab, we then check for
    // unsaved changes by using a variable (unsavedChangesOnTagsTab), which is populated and updated via an observable where the value is set and updated in the tags tab
    } else if (this.authenticatedTabList[this.tabSelected].name === 'tags') {
      if (this.unsavedChangesOnTagsTab) {
        showModal();
      } else {
        proceedSelection();
      }
    } else {
      proceedSelection();
    }
  }

  ngOnDestroy(): void {
    if (this.unsavedChangesOnAttributesSubscription) {
      this.unsavedChangesOnAttributesSubscription.unsubscribe();
    }

    if (this.unsavedChangesOnTagsSubscription) {
      this.unsavedChangesOnTagsSubscription.unsubscribe();
    }
  }
}
